import CompanyService from "src/services/CompanyService";
import ModuleCreator from "src/store/ModuleCreator";

export const types = {};
export const params = {
	name: "",
	users: "",
	organization_id: ""

};

/**
@namespace
@property  {object} module,
@property  {object} module.state,
@property  {object} modules.company,
@property  {array}  modules.companies
 **/

const module = {
	state: {},
	mutations: {},
	getters: {},
	actions: {},
	types: types
};
export default ModuleCreator({name: "company", plural: "companies"}, CompanyService, module, types, params);
